import {
  AppointmentStatus,
  AppointmentType,
  type EpisodeOfCare,
} from "@rmh/defs";

export enum EpisodeOfCareStatus {
  Unknown = 99,
  PreTriage = 0,
  PostTriage = 1,
  InProgress = 2,
  Completed = 3,
}

export const getEpisodeOfCareStatus = (eoc?: EpisodeOfCare) => {
  const triageAppointment = eoc?.appointments.find(
    (appt) => appt.appointmentType === AppointmentType.Triage
  );

  if (!triageAppointment?.appointmentStatus) {
    return EpisodeOfCareStatus.Unknown;
  }

  if (eoc?.episodeComplete) {
    return EpisodeOfCareStatus.Completed;
  }

  if (
    [
      AppointmentStatus.Scheduled,
      AppointmentStatus.Confirmed,
      AppointmentStatus.Ready,
    ].includes(triageAppointment.appointmentStatus)
  ) {
    return EpisodeOfCareStatus.PreTriage;
  }

  if (triageAppointment.appointmentStatus === AppointmentStatus.PostTriage) {
    return EpisodeOfCareStatus.PostTriage;
  }

  return EpisodeOfCareStatus.InProgress;
};

export const checkIsEpisodeOfCareActive = (eoc: EpisodeOfCare) => {
  return getEpisodeOfCareStatus(eoc) !== EpisodeOfCareStatus.Completed && eoc.assignedFollowUp && eoc.assignedFollowUp > 0;
};
